import React from 'react';
// cta
import Play from './cta/play.svg';
import ArrowRight from './icons/arrowRight.svg';
import ArrowUp from './icons/arrowUp.svg';
// Display Advertising
import Book from './icons/book.svg';
import Capital from './icons/capital.svg';
import Diamond from './icons/diamond.svg';
import Megaphone from './icons/megaphone.svg';
import Processing from './icons/processing.svg';
import WhiteBook from './icons/white-book.svg';
// page icons
import BackgroundCircles from './icons/background-circles.svg';
import Checkbox from './icons/checkbox.svg';
import PerpetuaLogo from './icons/logo.svg';
import Prism from './icons/prism.svg';
import Star from './icons/star.svg';

import Add from './icons/add.svg';
import Alert from './icons/alert.svg';
import Amazon from './icons/amazon.svg';
import Calendar from './icons/calendar.svg';
import Checkmark from './icons/checkmark.svg';
import CloseGray from './icons/close-gray.svg';
import Close from './icons/close.svg';
import Cloud from './icons/cloud.svg';
import Competitor from './icons/competitor.svg';
import CrumbSeparator from './icons/crumbSeparator.svg';
import Data from './icons/data.svg';
import Defense from './icons/defense.svg';
import Dollar from './icons/dollar.svg';
import DspBlack from './icons/dsp-black.svg';
import DspColor from './icons/dsp-color.svg';
import Dsp from './icons/dsp.svg';
import Edit from './icons/edit.svg';
import Ellipse from './icons/ellipse.svg';
import Eye from './icons/eye.svg';
import FunnelBlack from './icons/funnel-black.svg';
import Funnel from './icons/funnel.svg';
import Global from './icons/global.svg';
import Inbox from './icons/inbox.svg';
import IndigoCheckmark from './icons/indigo-checkmark.svg';
import InfoDark from './icons/info-dark.svg';
import Info from './icons/info.svg';
import Instacart from './icons/instacart.svg';
import KeywordBoost from './icons/keyword-boost.svg';
import Language from './icons/language.svg';
import Lightbulb from './icons/lightbulb.svg';
import Locker from './icons/locker.svg';
import Manager from './icons/manager.svg';
import Menu from './icons/menu.svg';
import Minus from './icons/minus.svg';
import OptimizeBid from './icons/optimize-bid.svg';
import Optimize from './icons/optimize.svg';
import Phone from './icons/phone.svg';
import Pie from './icons/pie.svg';
import Pin from './icons/pin.svg';
import Plus from './icons/plus.svg';
import ProcessingIndigo from './icons/processing-indigo.svg';
import QuestionMark from './icons/questionMark.svg';
import Quotes from './icons/quotes.svg';
import Replay from './icons/replay.svg';
import RightArrow from './icons/right-arrow.svg';
import Rocket from './icons/rocket.svg';
import SalesTraffic from './icons/sales-traffic.svg';
import Sales from './icons/sales.svg';
import SearchGradient from './icons/search-gradient.svg';
import SearchInsights from './icons/search-insights.svg';
import Search from './icons/search.svg';
import Send from './icons/send.svg';
import Sort from './icons/sort.svg';
import Store from './icons/store.svg';
import Team from './icons/team.svg';
import TimeGradient from './icons/time-gradient.svg';
import Time from './icons/time.svg';
import Tracking from './icons/tracking.svg';
import Union from './icons/union.svg';
import VideoAds from './icons/video-ads.svg';
import Video from './icons/video.svg';
import Walmart from './icons/walmart.svg';
import Webinar from './icons/webinar.svg';

// social icons
import Facebook from './social/facebook.svg';
import Instagram from './social/instagram.svg';
import Linkedin from './social/linkedin.svg';
import TikTok from './social/tiktok.svg';
import Twitter from './social/twitter_x.svg';
import Whatsapp from './social/whatsapp.svg';
import Youtube from './social/youtube.svg';

// icons
import Growth from './icons/growth.svg';
import Clock from './icons/shapeclock.svg';
import SonarListItemCheckMark from './icons/sonar-list-item-checkmark.svg';

export enum IconType {
  // cta
  play = 'Play',

  // page icons
  perpetua = 'Perpetua',
  backgroundCircles = 'BackgroundCircles',
  inbox = 'inbox',
  checkbox = 'Checkbox',
  close = 'Close',
  dsp = 'Dsp',
  lightbulb = 'Lightbulb',
  menu = 'Menu',
  optimize = 'Optimize',
  rocket = 'Rocket',
  sales = 'Sales',
  webinar = 'Webinar',
  funnel = 'Funnel',
  funnelBlack = 'FunnelBlack',
  language = 'language',
  video = 'Video',
  union = 'Union',
  instacart = 'Instacart',
  walmart = 'Walmart',
  ellipse = 'Ellipse',
  arrowRight = 'ArrowRight',
  arrowUp = 'ArrowUp',
  optimizeBid = 'OptimizeBid',
  sort = 'Sort',
  time = 'Time',
  edit = 'Edit',
  minus = 'Minus',
  add = 'Add',
  quotes = 'Quotes',
  star = 'Star',
  data = 'Data',
  rightArrow = 'RightArrow',
  alert = 'Alert',
  prism = 'Prism',
  locker = 'Locker',
  defense = 'defense',
  phone = 'phone',
  pie = 'pie',
  pin = 'pin',
  team = 'team',
  amazon = 'amazon',
  searchInsights = 'searchInsights',
  competitor = 'competitor',
  tracking = 'tracking',
  keywordBoost = 'keywordBoost',
  processingIndigo = 'processingIndigo',
  indigoCheckmark = 'indiogoCheckmark',
  closeGray = 'closeGray',
  searchGradient = 'searchGradient',
  timeGradient = 'timeGradient',
  salesTraffic = 'salesTraffic',
  calendar = 'calendar',
  questionMark = 'questionMark',
  crumbSeparator = 'crumbSeparator',
  videoAds = 'videoAds',
  send = 'send',

  // social icons
  facebook = 'Facebook',
  twitter = 'Twitter',
  linkedin = 'Linkedin',
  youtube = 'Youtube',
  instagram = 'Instagram',
  whatsapp = 'Whatsapp',
  tiktok = 'TikTok',

  // Display Advertising
  dspBlack = 'DspBlack',
  dspColor = 'DspColor',
  book = 'Book',
  whiteBook = 'WhiteBook',
  diamond = 'Diamond',
  capital = 'Capital',
  processing = 'Processing',
  megaphone = 'Megaphone',
  dollar = 'Dollar',
  global = 'Global',
  replay = 'Replay',
  eye = 'Eye',
  search = 'Search',
  store = 'Store',
  manager = 'Manager',
  cloud = 'Cloud',

  // pricing icons
  checkmark = 'Checkmark',
  plus = 'Plus',
  info = 'Info',
  infoDark = 'InfoDark',

  clock = 'Clock',
  sonarListItemCheckmark = 'SonarListItemCheckMark',
  growth = 'Growth',
}

const iconComponentMap = new Map<string, typeof React.Component>([
  [IconType.play, Play],

  [IconType.checkbox, Checkbox],
  [IconType.close, Close],
  [IconType.dsp, Dsp],
  [IconType.lightbulb, Lightbulb],
  [IconType.menu, Menu],
  [IconType.optimize, Optimize],
  [IconType.rocket, Rocket],
  [IconType.sales, Sales],
  [IconType.webinar, Webinar],
  [IconType.funnel, Funnel],
  [IconType.funnelBlack, FunnelBlack],
  [IconType.language, Language],
  [IconType.video, Video],
  [IconType.dsp, Dsp],
  [IconType.cloud, Cloud],
  [IconType.union, Union],
  [IconType.instacart, Instacart],
  [IconType.walmart, Walmart],
  [IconType.ellipse, Ellipse],
  [IconType.arrowRight, ArrowRight],
  [IconType.arrowUp, ArrowUp],
  [IconType.optimizeBid, OptimizeBid],
  [IconType.sort, Sort],
  [IconType.time, Time],
  [IconType.edit, Edit],
  [IconType.minus, Minus],
  [IconType.add, Add],
  [IconType.quotes, Quotes],
  [IconType.star, Star],
  [IconType.data, Data],
  [IconType.rightArrow, RightArrow],
  [IconType.alert, Alert],
  [IconType.prism, Prism],
  [IconType.locker, Locker],
  [IconType.defense, Defense],
  [IconType.phone, Phone],
  [IconType.pie, Pie],
  [IconType.pin, Pin],
  [IconType.team, Team],
  [IconType.amazon, Amazon],
  [IconType.searchInsights, SearchInsights],
  [IconType.competitor, Competitor],
  [IconType.tracking, Tracking],
  [IconType.keywordBoost, KeywordBoost],
  [IconType.processingIndigo, ProcessingIndigo],
  [IconType.indigoCheckmark, IndigoCheckmark],
  [IconType.closeGray, CloseGray],
  [IconType.salesTraffic, SalesTraffic],
  [IconType.timeGradient, TimeGradient],
  [IconType.searchGradient, SearchGradient],
  [IconType.perpetua, PerpetuaLogo],
  [IconType.backgroundCircles, BackgroundCircles],
  [IconType.calendar, Calendar],
  [IconType.questionMark, QuestionMark],
  [IconType.crumbSeparator, CrumbSeparator],
  [IconType.inbox, Inbox],
  [IconType.videoAds, VideoAds],

  [IconType.facebook, Facebook],
  [IconType.twitter, Twitter],
  [IconType.linkedin, Linkedin],
  [IconType.youtube, Youtube],
  [IconType.instagram, Instagram],
  [IconType.whatsapp, Whatsapp],
  [IconType.tiktok, TikTok],

  [IconType.dspBlack, DspBlack],
  [IconType.dspColor, DspColor],
  [IconType.book, Book],
  [IconType.whiteBook, WhiteBook],
  [IconType.dollar, Dollar],
  [IconType.diamond, Diamond],
  [IconType.capital, Capital],
  [IconType.processing, Processing],
  [IconType.megaphone, Megaphone],
  [IconType.global, Global],
  [IconType.replay, Replay],
  [IconType.eye, Eye],
  [IconType.search, Search],
  [IconType.store, Store],
  [IconType.manager, Manager],
  [IconType.send, Send],

  [IconType.checkmark, Checkmark],
  [IconType.plus, Plus],
  [IconType.info, Info],
  [IconType.infoDark, InfoDark],

  [IconType.clock, Clock],
  [IconType.sonarListItemCheckmark, SonarListItemCheckMark],
  [IconType.growth, Growth],
]);

interface IconProps {
  iconType: IconType;
  className?: string;
}

// Component for svg icons

const Icon: React.FC<IconProps> = props => {
  const { iconType, className } = props;
  const I = iconComponentMap.get(iconType);
  return <I className={className} />;
};

export default React.memo(Icon);
